module.exports = __webpack_public_path__ + "img/solution-eletric-intro-pg.4f02d563.png";